import { createGlobalStyle } from "styled-components";
import manropeExtraLight from "../assets/fonts/Manrope-ExtraLight.woff2";
import manropeLight from "../assets/fonts/Manrope-Light.woff2";
import manropeRegular from "../assets/fonts/Manrope-Regular.woff2";
import manropeMedium from "../assets/fonts/Manrope-Medium.woff2";
import manropeSemiBold from "../assets/fonts/Manrope-SemiBold.woff2";
import manropeBold from "../assets/fonts/Manrope-Bold.woff2";
import manropeExtraBold from "../assets/fonts/Manrope-ExtraBold.woff2";

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "Manrope";
    src: url(${manropeExtraLight}) format("woff2");
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeLight}) format("woff2");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeRegular}) format("woff2");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeMedium}) format("woff2");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeSemiBold}) format("woff2");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeBold}) format("woff2");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Manrope";
    src: url(${manropeExtraBold}) format("woff2");
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  button, input, textarea, select {
    font-family: inherit;
  }

  body {
    background-color:${({ theme }) => theme.colors.background};
    font-family: "Manrope", sans-serif;
    color: ${({ theme }) => theme.colors?.text};
    font-size: 1.25rem;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.lightBlue};
    color:${({ theme }) => theme.colors.accent};
  }

  .scroll-reveal-item {
    opacity: 0;
    transform: translate3d(0, 18px, 0);
    transition: opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .scroll-reveal-item.scroll-reveal-item--visible {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  @media (max-width: 520px) {
    .scroll-reveal-item {
      transform: translate3d(0, 12px, 0);
      transition-duration: 0.45s, 0.55s;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .scroll-reveal-item,
    .scroll-reveal-item.scroll-reveal-item--visible {
      opacity: 1;
      transform: none;
      transition: none;
    }
  }

  /* скроллбар */
  ::-webkit-scrollbar {
    width: 10px;       
    height: 10px;      
  }

  /* Фон дорожки */
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  /* Ползунок */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.scrollbar};
    border-radius: 10px;
  }

  /* Ползунок при наведении */
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.scrollbarHover};;
  }

  @media (min-width: 2500px) {
    ::-webkit-scrollbar {
      width: 14px;       
      height: 14px;      
    }
  
    ::-webkit-scrollbar-track {
      border-radius: 14px;
    }
  
    ::-webkit-scrollbar-thumb {
      border-radius: 14px;
    }
  }
  @media (min-width: 3000px) {
    ::-webkit-scrollbar {
      width: 20px;       
      height: 20px;     
    }
  
    ::-webkit-scrollbar-track {
      border-radius: 20px;
    }
  
    ::-webkit-scrollbar-thumb {
      border-radius: 20px;
    }
  }
`;
